/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 32b56e97ded2
 */

import * as z from "zod";
import { transformationsGetTransformation } from "../../funcs/transformationsGetTransformation.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  transformation: z.string().describe(
    "The transformation identifier. Can be either a named transformation (e.g., 'small_profile_thumbnail') or a transformation string (e.g., 'w_100,h_150,c_fill,g_auto').\n",
  ),
};

export const tool$transformationsGetTransformation: ToolDefinition<
  typeof args
> = {
  name: "get-transformation-details",
  description: `Retrieves details of a specific transformation

Retrieves details for a named or unnamed transformation.
`,
  scopes: ["admin"],
  annotations: {
    "title": "Get Transformation Details",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await transformationsGetTransformation(
      client,
      args.transformation,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
